var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatsmall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#3A3FE0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#F0F1F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1908_72276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1179 10.0318V10.0052C18.1048 9.57031 18.0983 9.02798 18.0076 8.49931C17.9169 7.96418 17.7225 7.38865 17.2946 6.94005C16.5039 6.10378 15.3761 6.01685 14.5075 5.99671C14.0992 5.98665 13.0476 5.98145 11.996 5.98145C10.9444 5.98145 9.89272 5.98665 9.48439 5.99671C8.60932 6.01691 7.48152 6.10378 6.68419 6.94005C6.26286 7.38865 6.07499 7.96411 5.97766 8.49931C5.88706 9.02798 5.88706 9.58365 5.87399 10.025C5.86752 10.7076 5.86752 11.3971 5.87399 12.0794C5.88052 12.5146 5.88706 13.0764 5.97766 13.6051C6.06846 14.1406 6.26286 14.7161 6.69072 15.1644C7.48152 16.001 8.60926 16.0879 9.47779 16.1077C10.0158 16.1214 11.6298 16.1279 12.9195 16.1279L15.3113 17.9212C15.3971 17.9856 15.4993 18.0185 15.6025 18.0185C15.6707 18.0185 15.7393 18.0042 15.8039 17.9749C15.9659 17.9013 16.0761 17.7408 16.0955 17.5602L16.2576 15.8401C16.4585 15.7665 16.6529 15.6731 16.8344 15.5524C16.9965 15.4453 17.152 15.3248 17.2945 15.1712C17.7224 14.7229 17.9169 14.1474 18.0075 13.6119C18.0983 13.0764 18.1047 12.5211 18.1113 12.0862C18.1113 11.7717 18.1243 11.4908 18.1307 11.1695C18.1307 10.788 18.1179 10.4133 18.1179 10.0318ZM9.50439 11.7405C9.09099 11.7405 8.75599 11.4016 8.75599 10.9843C8.75599 10.5663 9.09106 10.2278 9.50439 10.2278C9.91772 10.2278 10.2529 10.5663 10.2529 10.9843C10.2529 11.4016 9.91772 11.7405 9.50439 11.7405ZM11.9999 11.7405C11.5865 11.7405 11.2515 11.4016 11.2515 10.9843C11.2515 10.5663 11.5866 10.2278 11.9999 10.2278C12.4133 10.2278 12.7484 10.5663 12.7484 10.9843C12.7484 11.4016 12.4133 11.7405 11.9999 11.7405ZM14.4955 11.7405C14.0821 11.7405 13.747 11.4016 13.747 10.9843C13.747 10.5663 14.0821 10.2278 14.4955 10.2278C14.9089 10.2278 15.2439 10.5663 15.2439 10.9843C15.2439 11.4016 14.9088 11.7405 14.4955 11.7405Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1908_72276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatsmall);
export default __webpack_public_path__ + "static/media/chatsmall.3d15c4c958428072fd8818b18d35fa5d.svg";
export { ForwardRef as ReactComponent };